import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CImg
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import Cookies from 'universal-cookie'
const cookies = new Cookies();

class TheHeaderDropdown extends Component {
  constructor(props) {
    super(props);

    this.handleLogOut = this.handleLogOut.bind(this)
    this.handleChangePassword = this.handleChangePassword.bind(this)
    this.state = {
      login: false,
      username: "",
      role:"",
      inex:"in"
    };
  }

  componentDidMount(){
    if (cookies.get('iSense_user')) {
      let session_user = cookies.get('iSense_user')
      //console.log(session_user)
      this.setState({username: session_user.username, role: session_user.account_type, inex:session_user.status_in_ex})
    }
  }

  handleLogOut() {
    cookies.remove('iSense_user', {path: '/'})
    sessionStorage.clear()
    localStorage.clear()
    window.location.reload(false);
  }
  handleChangePassword() {
    this.props.history.push({
        pathname: '/changepassword'
      });
  }
  render(){  
  const {inex} = this.state
  return (
    <CDropdown
      inNav
      className="c-header-nav-items mx-2"
      direction="down"
    >
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        <b>{this.state.role} | {this.state.username} &ensp;</b>
        <div className="c-avatar">
          <CImg
            src={'avatars/icon_isense.png'}
            className="c-avatar-img"
            alt="admin@bootstrapmaster.com"
          />
        </div>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        {/*<CDropdownItem
          header
          tag="div"
          color="light"
          className="text-center"
        >
          <strong>Account</strong>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-bell" className="mfe-2" /> 
          Updates
          <CBadge color="info" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-envelope-open" className="mfe-2" /> 
          Messages
          <CBadge color="success" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-task" className="mfe-2" /> 
          Tasks
          <CBadge color="danger" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-comment-square" className="mfe-2" /> 
          Comments
          <CBadge color="warning" className="mfs-auto">42</CBadge>
        </CDropdownItem>*/}
        <CDropdownItem
          header
          tag="div"
          color="light"
          className="text-center"
        >
          <strong>Settings</strong>
        </CDropdownItem>
        { inex=="Eksternal" && 
        <CDropdownItem >
          <Link to="/changepassword">
          <CIcon name="cil-user" className="mfe-2" />Change Password
          </Link>
        </CDropdownItem>
        }
        {/*<CDropdownItem>
          <CIcon name="cil-credit-card" className="mfe-2" /> 
          Payments
          <CBadge color="secondary" className="mfs-auto">42</CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-file" className="mfe-2" /> 
          Projects
          <CBadge color="primary" className="mfs-auto">42</CBadge>
        </CDropdownItem>*/}
        <CDropdownItem divider />
        <CDropdownItem onClick={this.handleLogOut}>
          <CIcon name="cil-lock-locked" className="mfe-2" /> 
          Log out
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
  }
}

export default TheHeaderDropdown
